export default {"src":"/_next/static/media/infoBg.40ed424f.svg","height":92,"width":198,"blurWidth":0,"blurHeight":0};